export default "__VITE_ASSET__BytD$1BD__"